import type { PlaylistItem } from '@jwp/ott-common/types/playlist';
import { MEDIA_CONTENT_TYPE } from '@jwp/ott-common/src/constants';

import { isContentType } from './common';

export const hasWatchableContentType = (item: PlaylistItem) => {
  if (isContentType(item, MEDIA_CONTENT_TYPE.hub)) return false;
  if (isContentType(item, MEDIA_CONTENT_TYPE.liveChannel)) return false;
  if (isContentType(item, MEDIA_CONTENT_TYPE.page)) return false;

  return true;
};

export const hasVideo = (item: PlaylistItem) => {
  if (!hasWatchableContentType(item)) return false;

  return !!item.sources?.some((source) => {
    const file = source?.file?.toLowerCase() || '';

    return file.endsWith('.m3u8') || file.endsWith('.mpd') || file.endsWith('.mp4') || file.endsWith('.mov') || file.endsWith('.webm') || file.endsWith('.mkv');
  });
};
